// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as AuthVm$PorterinFeature from "../../../../../view-model/AuthVm.mjs";
import * as AuthStore$PorterinFeature from "../../../../../domain/store/AuthStore.mjs";
import * as AuthUtils$PorterinFeature from "../../../../../domain/helpers/AuthUtils.mjs";
import * as CityContext$PorterinFeature from "../../../../../../../contexts/city-context/CityContext.mjs";
import * as AuthInputCmp$PorterinFeature from "../../../common/AuthInputCmp.mjs";
import * as CommonHelper$PorterinFeature from "../../../../../../../shared/core/helpers/CommonHelper.mjs";
import * as AuthContextV1$PorterinFeature from "../../../../../view-model/contexts/auth-context/AuthContextV1.mjs";
import * as AuthButtonCmpV2$PorterinFeature from "../../../common/AuthButtonCmpV2.mjs";
import * as SignupFormStateV2$PorterinFeature from "./SignupFormStateV2.mjs";
import * as SignupFormInterfaceV2$PorterinFeature from "./SignupFormInterfaceV2.mjs";
import * as SignupWhatsappConsentCmpV2$PorterinFeature from "../SignupWhatsappConsentCmpV2.mjs";
import * as SignupFormV2ModuleScss from "../../../../styles/SignupFormV2.module.scss";

var styles = SignupFormV2ModuleScss;

function SignupFormCmpV2(Props) {
  var set_auth_state = Props.set_auth_state;
  var prefill = Props.prefill;
  var match = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var match$1 = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var set_user = match$1.set_user;
  var match$2 = React.useState(function () {
        return AuthVm$PorterinFeature.prefillMobile(prefill).length === 0;
      });
  var setIsMobileEmpty = match$2[1];
  var match$3 = React.useState(function () {
        return true;
      });
  var setIsEmailEmpty = match$3[1];
  var match$4 = React.useState(function () {
        return SignupFormStateV2$PorterinFeature.initialFormState(AuthVm$PorterinFeature.prefillMobile(prefill));
      });
  var setInitialInput = match$4[1];
  var match$5 = React.useState(function () {
        return true;
      });
  var whatsappConsent = match$5[0];
  var match$6 = React.useState(function () {
        
      });
  var setResponse = match$6[1];
  var response = match$6[0];
  var form = SignupFormInterfaceV2$PorterinFeature.Form.useForm(match$4[0], (function (output, callbacks) {
          SignupFormStateV2$PorterinFeature.onFormSubmit(output, callbacks, setResponse, set_auth_state, set_user, whatsappConsent, prefill);
        }));
  var getFieldError = function (field, _callback) {
    Curry._1(form.dirty, undefined);
    return CommonHelper$PorterinFeature.getError(field);
  };
  var getEmailFieldError = function (field, _callback) {
    var match = Curry._1(form.dirty, undefined);
    if (response === undefined) {
      return CommonHelper$PorterinFeature.getError(field);
    }
    if (response.TAG === /* Ok */0) {
      return CommonHelper$PorterinFeature.getError(field);
    }
    if (match) {
      return CommonHelper$PorterinFeature.getError(field);
    }
    var message = response._0;
    if (AuthUtils$PorterinFeature.checkErrorIsEmail(message)) {
      return message;
    }
    
  };
  React.useEffect((function () {
          var match = form.status;
          var exit = 0;
          if (typeof match === "number") {
            if (match !== /* Editing */0) {
              exit = 1;
            }
            
          } else if (match.TAG !== /* Submitting */0) {
            exit = 1;
          }
          if (exit === 1) {
            Curry._1(setInitialInput, (function (param) {
                    return form.input;
                  }));
            Curry._1(form.reset, undefined);
          }
          
        }), [form.status]);
  var match$7 = Curry._1(form.dirty, undefined);
  var tmp;
  if (response !== undefined && !(response.TAG === /* Ok */0 || match$7)) {
    var message = response._0;
    tmp = AuthUtils$PorterinFeature.checkErrorIsEmail(message) ? null : React.createElement("div", {
            className: styles["submit-button-error"]
          }, message);
  } else {
    tmp = null;
  }
  return React.createElement("form", {
              className: styles["signup-form"],
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(form.submit, undefined);
                })
            }, React.createElement("div", {
                  className: styles["field-wrapper"]
                }, React.createElement(AuthInputCmp$PorterinFeature.make, {
                      label: AuthStore$PorterinFeature.SignupV2.mobile_input_placeholder,
                      is_required: true,
                      is_filled: match$2[0],
                      children: React.createElement("input", {
                            className: styles["mobile-input"],
                            id: "mobile-input-field",
                            disabled: form.submitting,
                            maxLength: 10,
                            placeholder: "",
                            type: "text",
                            value: form.input.mobile,
                            onBlur: (function (param) {
                                Curry._1(form.blurMobile, undefined);
                              }),
                            onChange: (function ($$event) {
                                Curry._1(setIsMobileEmpty, (function (param) {
                                        return $$event.target.value.length === 0;
                                      }));
                                Curry._2(form.updateMobile, (function (input, value) {
                                        return {
                                                mobile: value,
                                                email: input.email
                                              };
                                      }), $$event.target.value);
                              })
                          }),
                      error: getFieldError(form.mobileResult, (function (field_errors) {
                              return field_errors.mobile;
                            })),
                      styles: styles.style
                    }), React.createElement(AuthInputCmp$PorterinFeature.make, {
                      label: AuthStore$PorterinFeature.SignupV2.email_input_placeholder,
                      is_required: true,
                      is_filled: match$3[0],
                      children: React.createElement("input", {
                            className: styles["mobile-input"],
                            id: "email-input-field",
                            disabled: form.submitting,
                            placeholder: "",
                            type: "text",
                            value: form.input.email,
                            onBlur: (function (param) {
                                Curry._1(form.blurEmail, undefined);
                              }),
                            onChange: (function ($$event) {
                                Curry._1(setIsEmailEmpty, (function (param) {
                                        return $$event.target.value.length === 0;
                                      }));
                                Curry._2(form.updateEmail, (function (input, value) {
                                        return {
                                                mobile: input.mobile,
                                                email: value
                                              };
                                      }), $$event.target.value);
                              })
                          }),
                      error: getEmailFieldError(form.emailResult, (function (field_errors) {
                              return field_errors.email;
                            })),
                      styles: styles.style
                    }), React.createElement(SignupWhatsappConsentCmpV2$PorterinFeature.make, {
                      consent: whatsappConsent,
                      set_consent: match$5[1]
                    })), React.createElement("div", {
                  className: styles["submit-button-wrapper"]
                }, React.createElement(AuthButtonCmpV2$PorterinFeature.make, {
                      is_disabled: !Curry._1(form.valid, undefined) || form.submitting,
                      class_name: styles["submit-container"],
                      event_name: AuthStore$PorterinFeature.Signup.ga_form_submit_event,
                      category: match.category,
                      submit_text: AuthStore$PorterinFeature.SignupV2.submit_button,
                      event_label: AuthUtils$PorterinFeature.signupGAEventLabel(form.input.mobile, form.input.email, whatsappConsent),
                      mobile: form.input.mobile
                    }), tmp));
}

var make = SignupFormCmpV2;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
